import React, { memo } from 'react';
import UnifiedPrintModal from '@/components/Print/UnifiedPrintModal';
import type { Invoice } from '@/types';
import type { InvoiceData } from '@/components/Print/InvoiceContent';

interface PrintBillPreviewModalProps {
  open: boolean;
  invoice: Invoice | null;
  onClose: () => void;
}

// Maps Invoice (app type) → InvoiceData (print type)
// IDs are kept so UnifiedPrintModal can fetch patient/doctor/clinic info
function toInvoiceData(inv: Invoice): InvoiceData {
  return {
    // Required by UnifiedPrintModal to fetch patient/doctor/clinic
    patient_id:      inv.patient_id,
    doctor_id:       inv.doctor_id,
    clinic_id:       inv.clinic_id,

    invoice_number:  inv.invoice_number,
    invoice_date:    inv.invoice_date,
    visit_date:      inv.invoice_date,   // visit_date not on Invoice yet
    invoice_status:  inv.status,         // Invoice.status → invoice_status
    subtotal:        inv.subtotal,
    discount_amount: inv.discount_amount,
    tax_amount:      inv.tax_amount,
    total_amount:    inv.total_amount,
    paid_amount:     inv.paid_amount,
    balance_due:     inv.balance_due,
    payment_mode:    undefined,          // lives on PaymentRecord, not Invoice
    notes:           inv.notes,
    items: inv.items?.map(item => ({
      service_name: item.service_name,
      category:     item.category,
      quantity:     item.quantity,
      unit_price:   item.unit_price,
    })),
  };
}

function PrintBillPreviewModal({ open, invoice, onClose }: PrintBillPreviewModalProps) {
  return (
      <UnifiedPrintModal
          open={open}
          onClose={onClose}
          type="invoice"
          data={invoice ? toInvoiceData(invoice) : null}
          title="Invoice Print Preview"
      />
  );
}

export default memo(PrintBillPreviewModal);